import type { GameDraft } from '../../../../shared/drafts';
import type { PublishedGame } from '../../../../shared/publications';
export type StationChoice = { id: string; label: string; correct: boolean; mediaUrl?: string };
export type StationQuestion = { id: string; prompt: string; mediaUrl?: string; choices: StationChoice[] };
/** `seed` engel/altın dizilimini yayına bağlar: aynı oyunda her öğrenci aynı parkuru koşar. */
export type StationRunConfig = { id: string; seed: string; questions: StationQuestion[] };
export function draftToStationRunConfig(source: Pick<GameDraft | PublishedGame, 'id' | 'questions' | 'maxLevels'>): StationRunConfig {
  return { id: source.id, seed: source.id, questions: Array.from({ length: source.maxLevels }, (_, i) => {
    const q = source.questions.find((candidate) => candidate.levels[0] === i + 1);
    if (!q) throw new Error(`${i + 1}. İstasyon Koşusu sorusu bulunamadı.`);
    return { id: q.id, prompt: q.prompt, mediaUrl: q.media?.url,
      choices: q.choices.map((c) => ({ id: c.id, label: c.text, correct: c.isCorrect, mediaUrl: c.media?.url })) };
  }) };
}
